export enum SubmissionStatus {
  'fillingOut',
  'submitting',
  'delivered',
  'error'
}
